import { render, staticRenderFns } from "./SwitchMethodComponent.vue?vue&type=template&id=28a19d7a&scoped=true"
import script from "./SwitchMethodComponent.vue?vue&type=script&lang=js"
export * from "./SwitchMethodComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a19d7a",
  null
  
)

export default component.exports